export default {
  dark: 'Mörk',
  light: 'Ljus',
};
